import { axios } from '@/utils/http'
import { TableResponse, Params } from '@/components/table'
import { Examinees } from '@/models/exam/examinees'
import { post as upload } from './upload'
import { paramsApdapter } from '@/utils/apdapter'

export async function post(
  id: string,
  file: File,
  onUploadProgress?: (progressEvent: any) => void
) {
  return await upload(`/exam/${id}/examinees/xls`, file, onUploadProgress)
}

export const curryGet = (examId: string) => async (params?: Params) => {
  const { data } = await axios.get(`/exam/${examId}/examinees`, {
    params: paramsApdapter(params)
  })
  return data as TableResponse<Examinees>
}

export const get = async (examId: string, params?: Params) =>
  curryGet(examId)(params)

export const patch = async (examId: string) => {
  const { data } = await axios.patch(`exam/${examId}/examinees`)
}
